import technicianSettings from "./technicianSettings";

export const formatMailtoLink = (email: string, subject: string): string => {
  let subjectTag = subject.length > 0 ? `subject=${encodeURIComponent(subject)}` : null;
  let ccTag =
    technicianSettings.mailto_CC.length > 0
      ? `cc=${encodeURIComponent(technicianSettings.mailto_CC)}`
      : null;
  let footerTag =
    technicianSettings.mailto_Footer.length > 0
      ? `body=%0D%0A${encodeURIComponent(technicianSettings.mailto_Footer)}`
      : null;

  const tags = [subjectTag, ccTag, footerTag].filter((x) => Boolean(x)).join("&");

  return `mailto:${email}?${tags}`;
};
